/* Copyright 2013 - 2024 Waiterio LLC */

export default 'https://www.imagelato.com/images/favicon-tiramisu-5562597b.svg'
